import React, { useState, useRef } from 'react';
import { TextField, Button, FormControl, InputLabel, Select, MenuItem, Snackbar, Alert } from '@mui/material';
import emailjs from '@emailjs/browser';

const EmploymentForm = () => {
    const form = useRef();

    const [contactMethod, setContactMethod] = useState('');
    const [hearAboutUs, setHearAboutUs] = useState('');
    const [fileDetails, setFileDetails] = useState(null);
    const [linkedin, setLinkedin] = useState('');
    const [linkedinError, setLinkedinError] = useState('');
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');
    const [openSnackbar, setOpenSnackbar] = useState(false);

    const servID = process.env.REACT_APP_SERVID;
    const tempID2 = process.env.REACT_APP_TEMPID2;
    const uid = process.env.REACT_APP_UID;

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm(servID, tempID2, form.current, uid)
            .then((result) => {
                console.log(result.text);
                form.current.reset();
                setEmail('');
                setLinkedin('');
                setHearAboutUs('');
                setContactMethod('');
                setFileDetails('');
                setOpenSnackbar(true);
            }, (error) => {
                console.log(error.text);
            });
        e.target.reset();
    };

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    const handleContactMethodChange = (event) => {
        setContactMethod(event.target.value);
    };

    const handleHearAboutUsChange = (event) => {
        setHearAboutUs(event.target.value);
    };

    const handleEmailChange = (event) => {
        const value = event.target.value;
        setEmail(value);

        // Regular expression pattern for validating email
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // Check if the input matches the email pattern
        if (!emailPattern.test(value)) {
            setEmailError('Invalid email address');
        } else {
            setEmailError('');
        }
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setFileDetails({ name: file.name, size: file.size, type: file.type });
        } else {
            setFileDetails(null);
        }
    };

    const handleLinkedinChange = (event) => {
        const value = event.target.value;
        setLinkedin(value);

        // Regular expression pattern for validating URL
        const urlPattern = /^(ftp|http|https):\/\/[^ "]+$/;
        
        // Check if the input matches the URL pattern
        if (!urlPattern.test(value)) {
            setLinkedinError('Invalid LinkedIn URL');
        } else {
            setLinkedinError('');
        }
    };

    return(
        <>
            <form className="mbr-form p-3" ref={form} onSubmit={sendEmail}>
                <p className='text-center h4 mb-3'>Employment Opportunities</p>
                <input type="hidden" value="Employment Opportunities" name='subject' />
                
                <div className="row">
                    <div className="col-md-4 mb-2">
                        <TextField size="small" label="Full Name" color="primary" type="text" required name="name" fullWidth />
                    </div>
                    <div className="col-md-4 mb-2">
                        <TextField size="small" label="Phone Number" color="primary" type="tel" required name="phoneNumber" fullWidth />
                    </div>
                    <div className="col-md-4 mb-2">
                        <TextField size="small" label="Email" color="primary" type="email" name="email" fullWidth 
                        value={email} onChange={handleEmailChange} error={!!emailError} helperText={emailError}/>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4 mb-2">
                        <FormControl fullWidth size="small">
                            <InputLabel color="primary" required id="contactMethodLabel">Preferred Contact Method</InputLabel>
                            <Select value={contactMethod} onChange={handleContactMethodChange} required color="primary" labelId="contactMethodLabel" label="Preferred Contact Method" name="contactMethod">
                                <MenuItem value="phone">Phone</MenuItem>
                                <MenuItem value="email">Email</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div className="col-md-4 mb-2">
                        <FormControl fullWidth size="small">
                            <InputLabel color="primary" required id="hearAboutUsLabel">How Did You Hear About Us</InputLabel>
                            <Select value={hearAboutUs} onChange={handleHearAboutUsChange} color="primary" labelId="hearAboutUsLabel" label="How Did You Hear About Us" name="hearAboutUs">
                                <MenuItem value="Friend/Family">Friend/Family</MenuItem>
                                <MenuItem value="Google">Google</MenuItem>
                                <MenuItem value="DoctorNurse">Doctor/Nurse</MenuItem>
                                <MenuItem value="Advertisement">Advertisement</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div className="col-md-4 mb-2">
                        <TextField size="small" label="Best Time to Reach You" placeholder="e.g. 9:00 AM - 12:00 PM" color="primary" type="text" name="bestTimeToReach" fullWidth/>
                    </div>
                </div>

                <div className='row'>
                    <div className="col-md-4 mb-2">
                        <TextField size="small" label="LinkedIn" color="primary" type="url" name="linkedIn" fullWidth
                            value={linkedin} onChange={handleLinkedinChange} error={!!linkedinError} helperText={linkedinError} />
                    </div>

                    <div className="col-md-8 mb-2 d-flex align-items-center">
                        <span className="me-2" style={{ fontSize: '0.9rem' }}>Resume:</span>
                        <input accept=".pdf,.png" id="resume" type="file" onChange={handleFileChange} style={{ display: 'none' }} name="my_file" />
                        <label htmlFor="resume">
                            <Button className='mx-4 mt-1' variant="contained" component="span" size="small"style={{ backgroundColor: '#1b8fc9' }}>Choose File
                            </Button>
                        </label>
                        {fileDetails && (
                            <p className='ms-3 mt-2' style={{ fontStyle: 'italic', color: '#1b8fc9', fontSize: '0.9rem' }}>
                                {fileDetails.name}
                            </p>
                        )}
                    </div>
                </div>

                <div className='row'>
                    <div className="col-12 mb-2">
                        <label style={{ fontSize: '0.9rem' }}>We will review your information and reach out within 14 days.</label>
                        <TextField multiline rows={3} size="small" label="Additional Notes" color="primary" type="text" name="additionalNotes" fullWidth />
                    </div>
                </div>

                <div className="text-center">
                    <Button type="submit" className="btn mt-2" style={{ color: 'white', backgroundColor: '#1b8fc9', borderRadius: '5px',padding: '6px 24px'}}>SEND</Button>
                </div>
            </form>

            <Snackbar 
                open={openSnackbar} 
                autoHideDuration={6000} 
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: '100%' }}>
                    Your application has been submitted successfully! We'll review it and get back to you within 14 days.
                </Alert>
            </Snackbar>
        </>
    )
}

export default EmploymentForm;